<template>
    <div class="echarts-contain">
        <div :id="id" class="o-echarts"></div>
        <div class="currentYear" v-if="$attrs.showYear">{{new Date().getFullYear()}}年</div>

    </div>
</template>

<script>
    import echarts from 'echarts';

    export default {
        name: 'lineCharts',
        props: {
            'data': Array,
            'color': String, // 如果是green则绿色模式，否则是白色模式
            'unit': String // 单位
        },
        data () {
            return {
                id: 'echarts_' + new Date().getTime() + Math.floor(Math.random() * 1000),
                echartObj: null,
                unitName: '条'
            };
        },
        mounted () {
            this.unitName = this.unit ? this.unit : '条';
            this.option = {
                xAxis: {
                    splitNumber: 100
                },
                dataZoom: [
                    {
                        type: 'inside',
                        start: 0,
                        end: 60,
                        zoomLock:true
                    }
                ],
                grid: {
                    top: 50,
                    right: 24,
                    left: 41
                },

                yAxis: {
                    name: ` 单位 (${this.unitName})`,
                    nameGap: '16',
                    splitNumber: 3,
                    nameTextStyle: {
                        color: '#999'
                    },
                    type: 'value',
                    'axisLine': { // y轴
                        'show': false
                    },
                    // 网格样式
                    'splitLine': {
                        show: true,
                        lineStyle: {
                            color: this.color === 'green' ? '#E9E9E9' : '#ffffff',
                            width: 0.5,
                            type: 'solid'
                        }
                    },
                    // interval: 5,
                    'axisTick': { // y轴刻度线
                        'show': false
                    },
                    'axisLabel': {
                        show: true,
                        textStyle: {
                            color: this.color === 'green' ? '#333' : '#ffffff'
                        }
                    }
                },
                lineStyle: {
                    color: this.color === 'green' ? 'rgba(54,179,116,0)' : 'rgba(255,255,255,1)',
                    width: 1
                },
                itemStyle: {
                    color: this.color === 'green' ? 'rgba(54,179,116,1)' : 'rgba(255,255,255,1)',
                    opacity: 1
                },
                series: {}
            }
            this.echartObj = echarts.init(document.getElementById(this.id));
            this.echartObj.setOption(this.setSeriesData(), true);
        },
        watch: {
            data: {
                handler (newValue, oldValue) {
                    for (let i = 0; i < newValue.length; i++) {
                        if (oldValue[i] !== newValue[i]) {
                            this.echartObj.setOption(this.setSeriesData(), true);
                        }
                    }
                },
                deep: true
            }
        },
        methods: {
            // 尝试返回数据后刷新试图
            freshCharts () {
                this.echartObj.setOption(this.setSeriesData(), true);
            },
            getXaxisData () {
                // 填入横轴数据
                if (this.data.length > 0) {
                    return this.data.map(item => {
                        return item.xAxis.toString().replace('-', '月')
                    });
                }
            },
            getSeriesData () {
                // 填入数据
                if (this.data.length > 0) {
                    return this.data.map(item => {
                        return item.num
                    });
                }
            },
            setSeriesData () {
                this.setOptions('xAxis', (() => {
                    return {
                        type: 'category',
                        boundaryGap: false,
                        splitNumber: 1000,
                        minInterval: 100,
                        data: this.getXaxisData(),
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: this.color === 'green' ? '#E9E9E9' : '#ffffff'
                            }
                        },
                        axisTick: { // y轴刻度线
                            show: false
                        },
                        axisLabel: {
                            interval: 4,
                            show: true,
                            textStyle: {
                                color: this.color === 'green' ? '#999999' : '#ffffff'
                            }
                        }
                    }
                })());
                this.setOptions('series', (() => {
                    return {
                        data: this.getSeriesData(),
                        type: 'line',

                        lineStyle: {
                            width: 1,
                            color: 'rgba(54,179,116,1)'
                        },
                        // smooth: true,
                        symbol: 'circle', // 拐点设置为实心
                        symbolSize: 6, // 拐点大小
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    { offset: 0, color: this.color === 'green' ? 'rgba(54,179,116,1)' : 'rgba(255,255,255,1)' },
                                    { offset: 1, color: this.color === 'green' ? 'rgba(54,179,116,0)' : 'rgba(255,255,255,0)' }
                                ])
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#fff', // 拐点颜色
                                borderColor: 'rgba(54,179,116,1)', // 拐点边框颜色
                                borderWidth: 1, // 拐点边框大小
                                label: {
                                    show: true,
                                    color: this.color === 'green' ? 'rgba(54,179,116,1)' : 'rgba(255,255,255,1)',
                                    formatter: function (param) {
                                        return param.value == '0' ? '' : param.value;
                                    }

                                }
                            },
                            emphasis: {
                                color: 'rgba(54,179,116,1)'// hover拐点颜色定义
                            }
                        }

                    }
                })());
                return this.option;
            },
            setOptions (objKey, objVal) {
                if (this.option[objKey] && typeof this.option[objKey] === 'object' && !Array.isArray(this.option[objKey])) {
                    this.option[objKey] = Object.assign(this.option[objKey], objVal);
                } else {
                    this.option[objKey] = objVal;
                }
                this.$set(this.option, objKey, this.option[objKey]);
            }
        }
    }
</script>

<style lang="less" scoped>
.echarts-contain{
    width: 100%;
    height: 100%;
    position: relative;
    .o-echarts {
        width: 100%;
        height: 99%;
        padding-bottom: 10px;

    }
    .currentYear{
        width: 100%;
        text-align: center;
        position: absolute;
        bottom: 0;
        padding-bottom: 16px;
        color: #999999;
        font-size: 12px;

    }
}
</style>
